import moment from "moment";
import React from "react";
import { marpolSelectors } from "../../../../../redux/app/marpol";
import { TBFL1Record } from "../../../../../redux/app/bfl-1/@types";
import { TBFL1D1 } from "../../../../../redux/app/bfl-1/groups/group-d";
import BFL1TableRows from "../BFL1TableRows";
import { IStore } from "../../../../../redux/store";
import { ConnectedProps, connect } from "react-redux";

type OwnProps = {
	bfl1Record: TBFL1Record;
	isStrikedOff?: boolean;
};
type BFL1D1PreviewProps = React.PropsWithChildren<OwnProps>;
function BFL1D1Preview(props: BFL1D1PreviewProps & PropsFromRedux) {
	const bfl1Record = props.bfl1Record as TBFL1D1;
	const operationDate = moment(bfl1Record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	function renderMain() {
		return (
			<BFL1TableRows
				record={bfl1Record}
				tableRows={[[operationDate, "D", "1", bfl1Record.remarks]]}
			/>
		);
	}

	return renderMain();
}

function mapStateToProps(store: IStore) {
	const marpolStore = marpolSelectors._getStore(store);

	return {};
}
const reduxConnector = connect(mapStateToProps, {});
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(BFL1D1Preview);
